import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <div className="exec-scope min-h-screen" data-testid="not-found-page">
      <Seo
        title="Page not found — Copper & Vine"
        description="The page you are looking for could not be found."
        path="/404"
        noindex
      />
      <section className="exec-container pt-24 md:pt-28 pb-24">
        <div className="max-w-2xl">
          <p className="exec-eyebrow">404</p>
          <h1 className="font-extralight text-[clamp(34px,4.8vw,58px)] leading-[1.1] mt-6">
            This page could not be found.
          </h1>
          <p className="exec-serif text-[clamp(18px,2vw,22px)] leading-[1.5] text-[color:var(--lead-ink)] mt-6">
            The link may be broken, or the page may have moved. Here is the way back in.
          </p>
          <div className="flex flex-wrap gap-x-8 gap-y-3 mt-9">
            <Link to="/" data-testid="notfound-home-link" className="exec-link">
              Home <ArrowRight size={14} />
            </Link>
            <Link to="/services" className="exec-link">
              Services <ArrowRight size={14} />
            </Link>
            <Link to="/work" className="exec-link">
              Work <ArrowRight size={14} />
            </Link>
            <Link to="/resources" className="exec-link">
              Resources <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
